/**
 * Prins: Layout
 *
 * @copyright 2023 i-fabrik GmbH
 * @author Heiko Pfefferkorn
 */

import header from './header';
import menu from './menu';
import module from './main/module';

// ------
// Public
// ------

const layout = () => {
	header();
	menu();
	module();
};

// Export
export default layout;
